import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LoadingSpinner } from './components/LoadingSpinner';
import { HomePage } from './pages/HomePage';
import { LandingPage } from './pages/LandingPage';
import { KartaPage } from './pages/KartaPage';
import { VenuePage } from './pages/VenuePage';
import { Topplistan } from './pages/Topplistan';
import { useVenueStore } from './store/useVenueStore';
import { AIAssistantDialog } from './components/AIAssistantDialog';
import './styles/venue-description.css';
import { TeamBuildingActivitiesPage } from './pages/TeamBuildingActivitiesPage';

function App() {
  const { showAIAssistant, setShowAIAssistant } = useVenueStore();

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-[#20232c]">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* New landing page */}
              <Route path="/" element={<LandingPage />} />
              
              {/* Map page (moved from homepage) */}
              <Route path="/konferens-kartan" element={<KartaPage />} />
              
              {/* Keep other existing routes */}
              <Route path="/venues/:venueId" element={<VenuePage />} />
              <Route path="/topplistan" element={<Topplistan />} />
              
              {/* Handle 404s and redirects */}
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/teambuilding-aktiviteter" element={<TeamBuildingActivitiesPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            
            {/* AI Assistant Dialog */}
            {showAIAssistant && (
              <AIAssistantDialog onClose={() => setShowAIAssistant(false)} />
            )}
          </Suspense>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;